import React from "react";
import { Accordion, AccordionSummary, List, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ArrowDropdown, ArrowUpIcon } from "../../../../../assets/icons";
import { FilterDefinition } from "../../../../../context/FiltersProvider/types";
import { FiltersListItem } from "./FiltersListItem";

type Props = {
	title: string;
	items: FilterDefinition[];
	icon?: React.ReactNode;
	expanded: boolean;
	onToggle: () => void;
};

export const FiltersAccordion: React.FC<Props> = ({ title, items, icon, expanded, onToggle }) => {
	const { t } = useTranslation("common");

	const hasItems = items.length > 0;

	return (
		<Accordion expanded={expanded} onChange={onToggle}>
			<AccordionSummary
				sx={{
					position: "sticky",
					top: 0,
					backgroundColor: "background.paper",
					zIndex: 10000,
					borderBottom: expanded ? "1px solid" : "none",
					borderColor: expanded ? "divider" : "transparent",
				}}
			>
				<Stack direction="row" justifyContent="space-between" alignItems="center" width="100%" px={2} py={0.5}>
					<Stack direction={"row"} spacing={1} alignItems="center">
						{icon}
						<Typography variant="subtitle2">{title}</Typography>
					</Stack>

					{expanded ? <ArrowUpIcon sx={{ mr: 0.5 }} /> : <ArrowDropdown sx={{ mr: 0.5 }} />}
				</Stack>
			</AccordionSummary>

			{hasItems ? (
				<List sx={{ p: 0 }}>
					{items.map((item) => (
						<FiltersListItem key={item.id} filter={item} />
					))}
				</List>
			) : (
				<Typography px={2} py={1} variant="body2">
					{t("no filters")}
				</Typography>
			)}
		</Accordion>
	);
};
